import React from 'react';
import { useTheme } from '@mui/material/styles';

import { PostStatuses } from '../../../Utils/Types';

const iconBulb = (color: any) => (
  <path
    d="M22.9988 18.999C24.5899 18.999 26.1159 19.6311 27.241 20.7562C28.3661 21.8813 28.9982 23.4073 28.9982 24.9984C28.9982 27.2182 27.7883 29.158 25.9985 30.1979V31.9977C25.9985 32.2629 25.8931 32.5172 25.7056 32.7048C25.5181 32.8923 25.2638 32.9976 24.9986 32.9976H20.999C20.7338 32.9976 20.4795 32.8923 20.292 32.7048C20.1044 32.5172 19.9991 32.2629 19.9991 31.9977V30.1979C18.2093 29.158 16.9994 27.2182 16.9994 24.9984C16.9994 23.4073 17.6315 21.8813 18.7566 20.7562C19.8817 19.6311 21.4077 18.999 22.9988 18.999ZM24.9986 33.9975V34.9974C24.9986 35.2626 24.8932 35.5169 24.7057 35.7044C24.5182 35.892 24.2639 35.9973 23.9987 35.9973H21.9989C21.7337 35.9973 21.4794 35.892 21.2919 35.7044C21.1043 35.5169 20.999 35.2626 20.999 34.9974V33.9975H24.9986ZM30.998 23.9985H33.9977V25.9983H30.998V23.9985ZM11.9999 23.9985H14.9996V25.9983H11.9999V23.9985ZM23.9987 13.9995V16.9992H21.9989V13.9995H23.9987ZM15.9195 16.4993L18.0493 18.639L16.6294 20.0489L14.4996 17.9291L15.9195 16.4993ZM27.9483 18.629L30.0681 16.4993L31.4979 17.9291L29.3682 20.0489L27.9483 18.629Z"
    fill={color}
  />
);
const iconCrown = (color: any) => (
  <g transform="translate(14,16) scale(1.15)">
    <path
      d="M15.4786 1.47238C15.1258 1.31803 14.7305 1.40623 14.4785 1.69445L11.5427 5.02867L8.72036 0.861291C8.55971 0.621896 8.29197 0.480148 8.00217 0.480148H8.0006C7.71238 0.480148 7.44306 0.621896 7.28084 0.861291L4.45848 5.02867L1.52431 1.69445C1.27074 1.40623 0.878572 1.32118 0.524204 1.47238C0.17141 1.62515 -0.0333355 1.97007 0.00446388 2.34177L0.724226 11.7727C0.724226 12.2499 1.11324 12.6389 1.59361 12.6389H14.4092C14.888 12.6389 15.2785 12.2499 15.277 11.8026L15.9952 2.35279C16.0345 1.97165 15.8314 1.62673 15.4786 1.47238Z"
      fill={color}
    />
  </g>
);
const iconTool = (color: any) => (
  <g transform="translate(14,16) scale(1.15)">
    <path
      d="M15.1333 12.1333L9.03331 6.03331C9.63331 4.49997 9.29998 2.66664 8.06664 1.43331C6.73331 0.0999752 4.73331 -0.166692 3.13331 0.599975L6.03331 3.49997L3.99998 5.53331L1.09998 2.63331C0.333308 4.23331 0.599975 6.23331 1.93331 7.56664C3.16664 8.79997 4.99998 9.13331 6.53331 8.53331L12.6333 14.6333C12.9 14.9 13.3333 14.9 13.5666 14.6333L15.1333 13.0666C15.4 12.8333 15.4 12.4 15.1333 12.1333Z"
      fill={color}
    />
  </g>
);
const iconLocationSearching = (color: any) => (
  <g transform="translate(11,11)">
    <path
      d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
      fill={color}
    />
  </g>
);

function MarkerIcon({ icon }: any) {
  const theme = useTheme();

  let markerProps;
  switch (icon) {
    case PostStatuses.TODO:
      markerProps = {
        icon: iconBulb('white'),
        borderColor: 'white',
        bgColor: theme.palette.primary.main,
      };
      break;
    case PostStatuses.DOING:
      markerProps = {
        icon: iconBulb(theme.palette.secondary.main),
        borderColor: theme.palette.secondary.main,
        bgColor: 'white',
      };
      break;
    case PostStatuses.SELECTED:
      markerProps = {
        icon: iconBulb(theme.palette.secondary.main),
        borderColor: theme.palette.secondary.main,
        bgColor: 'white',
      };
      break;
    case PostStatuses.ANSWERED:
      markerProps = {
        icon: iconBulb('white'),
        borderColor: 'white',
        bgColor: theme.palette.primary.main,
      };
      break;
    case PostStatuses.VALIDATED:
      markerProps = {
        icon: iconCrown(theme.palette.secondary.main),
        borderColor: theme.palette.secondary.main,
        bgColor: theme.palette.secondary.light,
      };
      break;
    case PostStatuses.DUPLICATE:
      markerProps = {
        icon: iconBulb('white'),
        borderColor: 'white',
        bgColor: theme.palette.primary.main,
      };
      break;
    case PostStatuses.IN_PROGRESS:
      markerProps = {
        icon: iconTool(theme.palette.secondary.main),
        borderColor: theme.palette.secondary.main,
        bgColor: theme.palette.secondary.light,
      };
      break;
    case PostStatuses.DONE:
      markerProps = {
        icon: iconCrown('white'),
        borderColor: 'white',
        bgColor: theme.palette.secondary.main,
      };
      break;
    case 'LocationSearching':
      markerProps = {
        icon: iconLocationSearching(theme.palette.primary.dark),
        borderColor: theme.palette.primary.dark,
        bgColor: theme.palette.primary.light,
      };
      break;
    default:
      markerProps = {
        icon: iconBulb('white'),
        borderColor: 'white',
        bgColor: theme.palette.primary.main,
      };
  }

  return (
    <svg
      width="46"
      height="108"
      viewBox="0 0 46 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M23 50.8571L22.2579 51.5274L23 52.349L23.7421 51.5274L23 50.8571ZM23 50.8571C23.7421 51.5274 23.7423 51.5272 23.7425 51.527L23.7432 51.5262L23.7457 51.5234L23.7548 51.5134L23.7887 51.4754C23.8184 51.4423 23.8617 51.3936 23.9179 51.3299C24.0304 51.2026 24.1942 51.0156 24.4021 50.7743C24.8179 50.2917 25.4102 49.5915 26.1202 48.7167C27.5393 46.9681 29.4332 44.5165 31.329 41.7066C33.2228 38.8996 35.1311 35.717 36.5689 32.5076C38.0008 29.3114 39 26.0148 39 23C39 14.1656 31.8344 7 23 7C14.1656 7 7 14.1656 7 23C7 26.0148 7.99923 29.3114 9.43115 32.5076C10.8689 35.717 12.7772 38.8996 14.671 41.7066C16.5668 44.5165 18.4607 46.9681 19.8798 48.7167C20.5898 49.5915 21.1821 50.2917 21.5979 50.7743C21.8058 51.0156 21.9696 51.2026 22.0821 51.3299C22.1015 51.3519 22.1194 51.3721 22.1357 51.3905C22.1666 51.4254 22.1919 51.4537 22.2113 51.4754L22.2452 51.5134L22.2543 51.5234L22.2568 51.5262L22.2575 51.527C22.2577 51.5272 22.2579 51.5274 23 50.8571Z"
          stroke={markerProps.borderColor}
          strokeWidth="2"
          fill={markerProps.bgColor}
        />
        {markerProps.icon}
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="-6"
          y="-5"
          width="57"
          height="119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default MarkerIcon;
